module.exports = __webpack_public_path__ + "img/noclass.59c12914.png";